<template>
  <section class="section bg-gray-light" id="communities" ref="communities">
    <div class="communities-wrapper">
      <b-container>
        <b-row>
          <b-col cols="12" md="6" class="">
            <transition name="fade">
              <div class="community-card wtm mx-auto border-transition meet" v-if="showCards">
                <span>
                <b-img fluid 
                  class=""
                  :src="'/communities/WTM.svg'"
                  alt="Women Techmakers: Ambassador and Organizer">
                </b-img>
                </span>
                <div class="description onhover">
                  <div class="text w-100">
                    <h3 class="mb-4 font-bad"> 
                      Women Techmaker Ambassador <br>
                      & WTM Cancun Organizer
                    </h3>
                    <div class="d-block plain-social-icons">
                      <a href="https://www.facebook.com/WTMCancun" target="_blank" rel="noreferrer">
                        <i class="fab fa-facebook-f"></i>
                      </a>
                      <a href="https://twitter.com/WTMCancun" class="ml-4" target="_blank" rel="noreferrer">
                        <i class="fab fa-twitter"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </b-col>
          <b-col cols="12" md="6" class="mt-4 mt-md-0">
            <transition name="fade">
              <div class="community-card gdg d-flex align-items-center justify-content-center border-transition meet mx-auto"  v-if="showCards">
                <span>
                  <img src="/communities/GDG.svg" alt="Google Developers Group: Co-organizer">
                </span>
                <div class="description onhover">
                  <div class="text w-100">
                    <h3 class="mb-4 font-bad"> 
                     GDG Cancun Co-Organizer
                    </h3>
                    <div class="d-block plain-social-icons">
                      <a href="https://www.facebook.com/GDGCancun/" target="_blank" rel="noreferrer">
                        <i class="fab fa-facebook-f"></i>
                      </a>
                      <a href="https://twitter.com/GDGcancun" class="ml-4" target="_blank" rel="noreferrer">
                        <i class="fab fa-twitter"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </section>
</template>

<script>
  export default {
    props: {
      showCards: {
        type: Boolean,
        required: true
      }
    }
  }
</script>

<style scoped>
.community-card{
  background-color: transparent;
  cursor: pointer;
  overflow: hidden;
  padding: 0 2rem;
  border: 0;
  position: relative !important;
  max-width: 280px;
  min-height: 266px;
}
.community-card h3{
  line-height: 1.5;
}
.community-card img{
  object-fit: contain;
  max-width: 100%;
  opacity: 0.4;
  transition: transform 1s;
}
.community-card.gdg{
  height: 100%;
  /*background-color: rgba(37,37,37,0.2);*/
}
.community-card.wtm{
  /*background-color: rgba(245,213,219,0.8);*/
}

.community-card .description{
  width: 100%;
  height: 100%;
  position: absolute;
  top:0px;
  left:0;
  opacity: 1;
  /*background: transparent;*/
  background-color: rgba(70, 247, 197, 0.3);
  color: var(--gray-dark);
  transition: all 0.5s linear;
  display: flex;
  align-items: center;
}
.community-card.gdg .description{
  background-color: rgba(44, 90, 170, 0.3);
}
.community-card:hover >img{
  transform: scale(1.5);
}

.community-card .description .text{
  font-size: 20px;
  padding: 0 0.5rem;
}


.border-transition{
  -webkit-transition: color 10s;
  transition: color 10s;
}
.border-transition > span:before,
.border-transition :after{
  border: 2px solid transparent;
  box-sizing: inherit;
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
}
.border-transition > span:before{
  top: 0;
  left: 0;
}
.border-transition > span:after{
  bottom: 0;
  right: 0;
}
.border-transition:hover > span:before,
.border-transition:hover > span:after{
  width: 100%;
  height: 100%;
}
.border-transition:hover > span:before{
  
  transition:
    width 0.5s ease-out,
    height 0.5s ease-out 0.5s;
}
.border-transition.wtm:hover > span:before{
  border-top-color: #46F7C5;
  border-right-color: #46F7C5;
}
.border-transition.gdg:hover > span:before{
  border-top-color: #2c5aaa;
  border-right-color: #2c5aaa;
}

.meet > span:after{
  top: 0;
  left: 0;
}
.meet.wtm:hover > span:before{
  border-top-color: #46F7C5;
  border-right-color: #46F7C5;
}
.meet.gdg:hover > span:before{
  border-top-color: #2c5aaa;
  border-right-color: #2c5aaa;
}
.meet:hover > span:after{
  transition:
    height 0.25s ease-out,
    width 0.25s ease-out 0.25s;
}
.meet.wtm:hover > span:after{
 border-bottom-color: #46F7C5;
  border-left-color: #46F7C5;
}
.meet.gdg:hover > span:after{
  border-bottom-color: #2c5aaa;
  border-left-color: #2c5aaa;
}
.plain-social-icons > a{
  color: var(--gray-dark);
  font-size: 20px;
}

@media (min-width: 768px){
  .community-card .description{
    top:-400px;
    left:0;
    opacity: 0;
    transition: all 0.5s linear;
  }
  .community-card:hover .description{
    opacity: 1;
    transform: translateY(400px);
  }
  .community-card{
    max-width: 400px;
  }
}
</style>